import { QueryClient } from "@tanstack/react-query";

/** Shared QueryClient so redux actions / mutations can invalidate UrStudio caches after sync. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
